import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireOrgFeature } from '../../lib/orgFeatureGate';

// /financials/scenarios layout — list (index.tsx) + 4-step wizard ($scenarioId.tsx).
//
// SIL-1108: `orgFeature: 'scenarios'` (customerNav.ts) is business-only,
// distinct from the parent `/financials` layout's `'finance'` gate — gated
// here too so a direct hit on this subtree is covered even if a future org
// type unlocks one feature without the other. Same beforeLoad-before-any-
// child pattern as financials.tsx/market-intelligence.tsx.
export const Route = createFileRoute('/financials/scenarios')({
  beforeLoad: () => requireOrgFeature('scenarios'),
  component: () => <Outlet />,
});
